<template>
	<el-date-picker
		v-model="dateRange"
		type="daterange"
		@change="$emit('date-select',dateRange)"
		format="MM/dd/yyyy"
		range-separator="|"
		class="range-datepicker"
		start-placeholder="Start date"
		end-placeholder="End date">
	</el-date-picker>
</template>

<script>
/**
 * A generic date range picker for the Provider app
 */
export default {
	name: 'date-range-picker',
	props: {
		/**
		 * Setting date for the date picker when passed from parent
		 */
		dateSet: {
			type: Array,
			validator: dateValue =>  dateValue.length <= 2
		}
	},
	watch: {
		dateSet: {
			immediate: true,
			handler: function(newValue) {
				if(newValue) {
					this.dateRange = [...newValue]
				}
				
			}
		}
	},
	data() {
		return {
			dateRange:[]
		}
	},
	methods: {
		dateSelect() {
			console.log(this.dateRange)
		}
	}
}
</script>

<style scoped>
.range-datepicker >>> .el-range-separator{
	font-size: 20px;
	margin-top: 10px;
	color: #cccccc;
}
</style>
